<template>
    <div class="sidebar-box">
        <a-icon type="right-circle" style="fontSize:30px;color:#3d86ef" theme="filled" v-show="isOpenShow" @click="showDrawer" />              
        <span 
        class="device-total" 
        v-show="isOpenShow"
        >设备总数（26534）</span>
        <a-drawer
          title="设备总数（26534）"
          placement="left"
          :closable="false"
          :visible="visible"
          :mask="false"
          :maskClosable="false"
          :width="320"
          wrapClassName="sidebar-content"
        >
          <div class="select-box" v-show="selectIsShow">
              <a-select defaultValue="lucy" style="width:100%;padding:0 10px;" @change="handleSelectChange" size="small">
                <a-select-option value="jack">Jack</a-select-option>
                <a-select-option value="lucy">Lucy</a-select-option>
                <a-select-option value="Yiminghe">yiminghe</a-select-option>
              </a-select>
          </div>
          <div class="search-box">
              <a-input-search
                  placeholder=""
                  style="width:230px"
                  @search="onSearch"
                  enterButton
                  size="small"
              />
              <img @click="selectBar" src="../../assets/open_icon.png" style="position:absolute;right:10px;cursor:pointer;" />
          </div>
          <div class="tab-box">
            <a-tabs defaultActiveKey="1" type="card" @change="callback" :tabBarGutter="2">
                <a-tab-pane tab="全部(16534)" key="1">
                      <a-list
                        class="tab-content"
                        itemLayout="horizontal"
                        :dataSource="data"
                      >
                        <a-list-item slot="renderItem" slot-scope="item, index" @click="userPoint">
                          <a-list-item-meta>
                            <img slot="avatar" v-if="item.isStatus=='离线'" src="../../assets/point_offline_icon.png" />
                            <img slot="avatar" v-else src="../../assets/point_online_icon.png" />
                            <a slot="title">{{item.title}}</a>
                            <a slot="title">{{item.belong}}</a>
                            <a slot="title">{{item.group}}</a>
                            <a slot="title" v-if="item.isStatus=='在线'" class="device-online">{{item.isStatus}}</a>
                            <a slot="title" v-else class="device-offline">{{item.isStatus}}</a>
                          </a-list-item-meta>
                        </a-list-item>
                      </a-list>
                      <div class="page-box" id="components-pagination-demo-mini">
                        <a-pagination size="small" :total="50" showQuickJumper />
                      </div>
                </a-tab-pane>
                <a-tab-pane tab="在线(16000)" key="2" forceRender>
                      <a-list
                        class="tab-content"
                        itemLayout="horizontal"
                        :dataSource="dataOnline"
                      >
                        <a-list-item slot="renderItem" slot-scope="item, index" @click="userPoint">
                          <a-list-item-meta>
                            <img slot="avatar" src="../../assets/point_online_icon.png" />
                            <a slot="title">{{item.title}}</a>
                            <a slot="title">{{item.belong}}</a>
                            <a slot="title">{{item.group}}</a>
                            <a slot="title" class="device-online">{{item.isOnlineStatus}}</a>
                          </a-list-item-meta>
                        </a-list-item>
                      </a-list>
                      <div class="page-box" id="components-pagination-demo-mini">
                        <a-pagination size="small" :total="50" showQuickJumper />
                      </div>
                </a-tab-pane>
                <a-tab-pane tab="离线(534)" key="3">
                      <a-list
                        class="tab-content"
                        itemLayout="horizontal"
                        :dataSource="dataOffline"
                      >
                        <a-list-item slot="renderItem" slot-scope="item, index" @click="userPoint">
                          <a-list-item-meta>
                            <img slot="avatar" src="../../assets/point_offline_icon.png" />
                            <a slot="title">{{item.title}}</a>
                            <a slot="title">{{item.belong}}</a>
                            <a slot="title">{{item.group}}</a>
                            <a slot="title" class="device-offline">{{item.isOfflineStatus}}</a>
                          </a-list-item-meta>
                        </a-list-item>
                      </a-list>
                      <div class="page-box" id="components-pagination-demo-mini">
                        <a-pagination size="small" :total="50" showQuickJumper />
                      </div>
                </a-tab-pane>
                <a-tab-pane tab="告警" key="4">Content of Tab Pane 4</a-tab-pane>
            </a-tabs>
           </div>  
           <a-icon type="left-circle" v-show="isCloseShow" @click="onClose" style="fontSize:22px;color:#fff;" theme="twoTone" />                  
        </a-drawer>        
    </div>
</template>
<style scoped>
  #components-pagination-demo-mini .ant-pagination:not(:last-child){margin-bottom:24px;}
</style>
<script>
    // import BMap from 'BMap'

    const data = [
      {
        title: '刘三姐 1',
        belong: '机构123',
        group: '分组',
        isStatus: '在线'
      },
      {
        title: '刘三姐 2',
        belong: '机构123',
        group: '分组',
        isStatus: '在线'
      },
      {
        title: '刘三姐 3',
        belong: '机构123',
        group: '分组',
        isStatus: '离线'
      },
      {
        title: '刘三姐 4',
        belong: '机构123',
        group: '分组',
        isStatus: '离线'
      },
      {
        title: '刘三姐 5',
        belong: '机构123',
        group: '分组',
        isStatus: '在线'
      },
      {
        title: '刘三姐 6',
        belong: '机构123',
        group: '分组',
        isStatus: '在线'
      },
      {
        title: '刘三姐 7',
        belong: '机构123',
        group: '分组',
        isStatus: '离线'
      },
      {
        title: '刘三姐 8',
        belong: '机构123',
        group: '分组',
        isStatus: '离线'
      },
      {
        title: '刘三姐 9',
        belong: '机构123',
        group: '分组',
        isStatus: '离线'
      },
      {
        title: '刘三姐 10',
        belong: '机构123',
        group: '分组',
        isStatus: '在线'
      },
      {
        title: '刘三姐 11',
        belong: '机构123',
        group: '分组',
        isStatus: '离线'
      },
      {
        title: '刘三姐 12',
        belong: '机构123',
        group: '分组',
        isStatus: '离线'
      },
      {
        title: '刘三姐 13',
        belong: '机构123',
        group: '分组',
        isStatus: '离线'
      },
      {
        title: '刘三姐 14',
        belong: '机构123',
        group: '分组',
        isStatus: '在线'
      },
      {
        title: '刘三姐 15',
        belong: '机构123',
        group: '分组',
        isStatus: '在线'
      },
      {
        title: '刘三姐 16',
        belong: '机构123',
        group: '分组',
        isStatus: '离线'
      },
      {
        title: '刘三姐 17',
        belong: '机构123',
        group: '分组',
        isStatus: '离线'
      },
      {
        title: '刘三姐 18',
        belong: '机构123',
        group: '分组',
        isStatus: '离线'
      },
      {
        title: '刘三姐 19',
        belong: '机构123',
        group: '分组',
        isStatus: '离线'
      },
      {
        title: '刘三姐 20',
        belong: '机构123',
        group: '分组',
        isStatus: '在线'
      },
      {
        title: '刘三姐 21',
        belong: '机构123',
        group: '分组',
        isStatus: '在线'
      },
    ]
    const dataOnline = [
      {
        title: '刘三姐 1',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 2',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 3',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 4',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 5',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 6',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 7',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 8',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 9',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 10',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 11',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 12',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 13',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 14',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 15',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 16',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 17',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 18',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 19',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 20',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
      {
        title: '刘三姐 21',
        belong: '机构123',
        group: '分组',
        isOnlineStatus: '在线'
      },
    ]
    const dataOffline = [
      {
        title: '刘三姐 1',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 2',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 3',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 4',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 5',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 6',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 7',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 8',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 9',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 10',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 11',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 12',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 13',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 14',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 15',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 16',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 17',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 18',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 19',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 20',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
      {
        title: '刘三姐 21',
        belong: '机构123',
        group: '分组',
        isOfflineStatus: '离线'
      },
    ]

    export default {
      data () {
        return {
          visible: true,
          isOpenShow: true,
          isCloseShow: true,
          selectIsShow: false,
          data,
          dataOnline,
          dataOffline,
        }
      },
      methods: {
         showDrawer() {
            this.visible = true
            this.isOpenShow = false
            this.isCloseShow = true
         },
         onClose() {
            this.visible = false
            this.isOpenShow = true
            this.isCloseShow = false
         },
         callback (key) {
           console.log(key)
         },
         onSearch (value) {
           console.log(value)
         },
         userPoint() {
              // let carid = 13660;
              // let point = new BMap.Point(116.312237, 39.914333);    
              // baiduMapMarkerInfo(map);
              // let marker = {};
              // let allOverlay = map.getOverlays();        
              // for (let j=0;j<allOverlay.length;j++) {            
              //     if (allOverlay[j].CarID == carid) {
              //         marker = allOverlay[j];
              //     }
              // }
              // map.centerAndZoom(point, map.getZoom());
              // infoBoxTemp.open(marker);
         },
         selectBar() {
             this.selectIsShow = !this.selectIsShow
         },
         handleSelectChange() {

         }
      },
    }
</script>